import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatBadgeModule } from '@angular/material/badge';
import { TranslateModule } from '@ngx-translate/core';

import { SharedBasketSidenavUiModule } from '@lib/basket-sidenav';
import { BasketHeaderComponent } from './basket-header/basket-header.component';
import { BasketHeaderContentComponent } from './basket-header-content/basket-header-content.component';

@NgModule({
    imports: [CommonModule, MatBadgeModule, SharedBasketSidenavUiModule, TranslateModule],
    declarations: [BasketHeaderComponent, BasketHeaderContentComponent],
    exports: [BasketHeaderComponent, BasketHeaderContentComponent],
})
export class SharedBasketHeaderUiModule {}
